import styles from './SelectedGroupsList.module.scss';

import { ListItem } from '@mui/material';
import { Table } from '@tanstack/react-table';
import React, { useCallback } from 'react';

import {
  DraggableItem,
  IDraggableCellProps,
} from '@work4all/components/lib/components/draggable-item/DraggableItem';
import { Chip } from '@work4all/components/lib/dataDisplay/chip/Chip';

import { reorder } from '@work4all/utils/lib/reorder';
import { DndTypes } from '@work4all/utils/lib/variables';

interface IGroupListProps {
  table: Table<unknown>;
}

export const SelectedGroupsListV8: React.FC<IGroupListProps> = (props) => {
  const { table } = props;

  const state = table.getState();

  const removeGroupBy = (colId: string) => {
    table.setGrouping((old) => old.filter((id) => id !== colId));
  };

  const onDragEnd: IDraggableCellProps['onDragEnd'] = useCallback(
    (dragItem, dropTarget) => {
      if (dragItem.type === DndTypes.GROUP_CHIP) {
        const dragIndex = state.grouping.indexOf(dragItem.id);
        const dropIndex = state.grouping.indexOf(dropTarget.id);
        const newGrouping = reorder([...state.grouping], dragIndex, dropIndex);

        table.setGrouping(newGrouping);
        return;
      }

      const moved = dragItem.id;
      const col = table.getColumn(moved);
      const dropIndex = state.grouping.indexOf(dropTarget.id) + 1;

      if (state.grouping.indexOf(moved) === -1 && col?.getCanGroup()) {
        const newGrouping = [...state.grouping];
        newGrouping.splice(dropIndex, 0, moved);
        table.setGrouping(newGrouping);
      }
    },
    [state.grouping, table]
  );

  if (!state.grouping.length) {
    return null;
  }

  return (
    <div className={styles.root}>
      {state.grouping.map((colId) => {
        return (
          <DraggableItem
            key={colId}
            accept={[DndTypes.BASIC_TABLE_COL, DndTypes.GROUP_CHIP]}
            type={DndTypes.GROUP_CHIP}
            id={colId}
            onDragEnd={onDragEnd}
          >
            {(itemRef) => {
              return (
                <ListItem className={styles['list-item']} ref={itemRef}>
                  <Chip
                    label={table.getColumn(colId)?.columnDef.header as string}
                    handleDelete={() => {
                      removeGroupBy(colId);
                    }}
                  />
                </ListItem>
              );
            }}
          </DraggableItem>
        );
      })}
    </div>
  );
};
